export const DB_NAME = "fileCacheDB";
export const STORE_NAME = "chatFiles";
